import { useAppSelector } from '@/store/hooks';
import { getWorkingProjectSessions } from '@/store/slices/project/selectors';
import useGetProjectPublishedStatus from '@/connection/projects/use-get-project-published-status';
import { canAccessModerator } from '@/types/permissions.types';
import AuthWrapper from '@ui/auth-wrapper/auth-wrapper';
import ModerationButton from '../../../project-overview/components/session-action-items/moderation-button';

const ModerationEntryPoint = () => {
  useGetProjectPublishedStatus();

  const sessions = useAppSelector(getWorkingProjectSessions);
  const sessionUuid = sessions?.[0]?.uuid;

  return (
    <AuthWrapper allowedRoles={canAccessModerator}>
      <ModerationButton isGradient sessionUuid={sessionUuid} />
    </AuthWrapper>
  );
};

export default ModerationEntryPoint;
